import { useContext, useEffect, useState } from "react";
import { SuccessAlertContext } from "App";
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TableBody, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { PrefProduct, PrefStockList } from "../types";
import { chunkArray } from "../utils/common";
import { prefectures } from "../constants";
import { TableCellNarrow, TableHeaderCellNarrow } from "./TableCellSmall";

type Props = {
  open: boolean;
  onClose: Function;
  selectedPrefProduct: PrefProduct | undefined;
  getPrefStock: (p: PrefProduct) => Promise<void>;
  prefStockList: PrefStockList,
  isLoading: boolean;
};

const prefElement = (labels: string[], stockList: string[]) => (
  <Grid container spacing={2}>
    {stockList.map((s, i) => (
      // eslint-disable-next-line react/no-array-index-key
      <Grid item key={i} xs={2}>
        <Typography>{labels[i]}</Typography>
        <Typography>{s}</Typography>
      </Grid>
    ))}
  </Grid>
);

const prefTable = (labels: string[], stockList: string[]) => (
  <TableContainer>
    <TableHead>
      <TableRow>
        <TableHeaderCellNarrow>都道府県</TableHeaderCellNarrow>
        <TableHeaderCellNarrow>在庫数</TableHeaderCellNarrow>
      </TableRow>
    </TableHead>
    <TableBody>
      {stockList.map((s,i) => (
        <TableRow>
          <TableCellNarrow>{labels[i]}</TableCellNarrow>
          <TableCellNarrow>{s}</TableCellNarrow>
        </TableRow>
      ))}
    </TableBody>
  </TableContainer>
);

const chunkNumber = 12;

/**
 * 都道府県ごとに在庫数を表示
 * @param root0 コンポーネントのプロップス
 */
export default function PrefDialog({
  open,
  onClose,
  selectedPrefProduct,
  getPrefStock,
  prefStockList,
  isLoading,
}: Props) {
  const { showAlert } = useContext(SuccessAlertContext);

  useEffect(() => {
    (async () => {
      if (open) {
        console.log('selectedPrefProduct: ', selectedPrefProduct);
        if (!selectedPrefProduct) {
          showAlert('商品を選択してください。', 'error');
          return;
        }
        await getPrefStock(selectedPrefProduct);
      }
    })();
  }, [open]);
  return (
    <Dialog open={open} onClose={() => onClose()} PaperProps={{sx: {position: 'relative', width: 600}}}>
      <DialogTitle>都道府県ごとの在庫（商品コード: {selectedPrefProduct?.productCd}）</DialogTitle>
      <DialogContent sx={{maxWidth: 600}}>
        <Box mx={2}>
          {/* {(() => {
            const quatroPrefLabels = chunkArray(prefectures, chunkNumber, 1);
            const quatroPrefAmounts = chunkArray(prefStockList, chunkNumber);
            const elements = quatroPrefAmounts.map((quatroAmount, index) => (
              prefElement(quatroPrefLabels[index], quatroAmount)
            ))
            return elements;
          })()} */}
          {(() => {
            const quatroPrefLabels = chunkArray(prefectures, chunkNumber, 1);
            const quatroPrefAmounts = chunkArray(prefStockList, chunkNumber);
            const elements = quatroPrefAmounts.map((quatroAmount, index) => (
              prefTable(quatroPrefLabels[index], quatroAmount)
            ))
            return (
              <Box display="flex" flexDirection="row" justifyContent="space-evenly">
                {elements}
              </Box>
            );
          })()}

        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="custom-outlined" onClick={() => onClose()}>閉じる</Button>
      </DialogActions>
      {isLoading && // マスク
        <Box sx={{
          position: 'absolute',
          inset: 0,
          bgcolor: 'rgba(0,0,0,0.2)',
          zIndex: (theme) => theme.zIndex.modal + 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          <CircularProgress />
        </Box>
      }
    </Dialog>
  );
}